export function sortPlansByPriority(plans: any[], changedPlanId: number | null): any[] {
  return [...plans].sort((a, b) => {
    const priority = (plan: any) => {
      if (changedPlanId !== null && Number(plan.id) === Number(changedPlanId)) { return 0; }
      if (plan.recommended) { return 1; }
      if (plan.selected_from_lp) { return 2; }
      return 3;
    };
    return priority(a) - priority(b);
  });
}
